const deleteModalItem = (state = "", action) => {
    switch(action.type) {
        case 'deleteModalItem':
            return action.payload;
        default:
            return state;
    }
}

export default deleteModalItem;